module.exports = __webpack_public_path__ + "static/media/sho_leftde75b63c559c8354914f8fc9b0cdb98c.webp";